import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { LanguageDialogComponent } from './language.dialog.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ImageModule } from 'primeng/image';

@NgModule({
    declarations: [
      LanguageDialogComponent,
    ],
    imports: [
      CommonModule,
        TranslateModule,
        DialogModule,
        DynamicDialogModule,
        ButtonModule,
        RouterModule,
        ImageModule
    ],
})
export class LanguageDialogModule { }
